import React from 'react'
import { useTranslation } from 'react-i18next'
import { ContainedButtonVariant } from '../Buttons/ContainedButton'
import { TextButtonVariant } from '../Buttons/TextButton'
import ConfirmWithButtonsModal from './ConfirmWithButtonsModal'

interface TranscriptConfirmMarkAsSentModalProps {
  isOpen: boolean
  onConfirm: () => void
  onCancel: () => void
  transcriptName: string
}

const TranscriptConfirmMarkAsSentModal: React.FC<
  TranscriptConfirmMarkAsSentModalProps
> = ({ isOpen, onConfirm, onCancel, transcriptName }) => {
  const { t } = useTranslation()
  return (
    <ConfirmWithButtonsModal
      isOpen={isOpen}
      title={t(
        'Transcript.TranscriptFormCard.MarkAsSentModal.Title',
        'Mark as sent'
      )}
      question={t(
        'Transcript.TranscriptFormCard.MarkAsSentModal.Question',
        'Are you sure you want to mark the `{{transcriptName}}` transcript as sent to Parchment?',
        {transcriptName}
      )}
      questionProps={{ variant: 'body1', align: 'center' }}
      confirmVariant={ContainedButtonVariant.YesImSure}
      cancelVariant={TextButtonVariant.NoCancel}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  )
}

export default TranscriptConfirmMarkAsSentModal
